if (!customElements.get('comp-product-card')) {
  class CompProductCard extends HTMLElement {
    connectedCallback() {
      this._primaryImg = this.querySelector('[data-card-primary-image]');
      this._secondaryImg = this.querySelector('[data-card-secondary-image]');
      this._defaultPrimarySrc = this._primaryImg ? this._primaryImg.getAttribute('data-default-src') : null;

      this.querySelectorAll('.card__swatch').forEach((btn) => {
        btn.addEventListener('click', this._onSwatchClick.bind(this));
      });

      const moreBtn = this.querySelector('[data-swatch-more]');
      if (moreBtn) moreBtn.addEventListener('click', this._onMoreClick.bind(this));

      this._initSizes();
    }

    _initSizes() {
      const sizeBtns = this.querySelectorAll('.comp-size-btn');
      sizeBtns.forEach((btn) => {
        btn.addEventListener('click', this._onSizeClick.bind(this));
      });
      const firstAvail = this.querySelector('.comp-size-btn:not(.comp-size-btn--sold-out)');
      if (firstAvail) this._selectSize(firstAvail);
    }

    _onSizeClick(e) {
      this._selectSize(e.currentTarget);
    }

    _selectSize(btn) {
      this.querySelectorAll('.comp-size-btn').forEach((b) => {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');

      const variantId = btn.dataset.variantId;
      const variantInput = this.querySelector('.product-variant-id');
      if (variantInput && variantId) variantInput.value = variantId;

      const submitBtn = this.querySelector('.comp-card__atc-btn[type="submit"]');
      if (submitBtn) {
        const avail = btn.dataset.available !== 'false';
        submitBtn.disabled = !avail;
      }
    }

    _onSwatchClick(e) {
      const btn = e.currentTarget;

      this.querySelectorAll('.card__swatch').forEach((b) => {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');

      const primaryImg = btn.dataset.primaryImage;
      const secondImg = btn.dataset.secondImage;

      if (this._primaryImg) {
        this._primaryImg.src = primaryImg || this._defaultPrimarySrc;
        this._primaryImg.srcset = '';
        this._primaryImg.removeAttribute('width');
        this._primaryImg.removeAttribute('height');
      }

      if (this._secondaryImg) {
        if (secondImg) {
          this._secondaryImg.src = secondImg;
          this._secondaryImg.srcset = '';
          this._secondaryImg.removeAttribute('width');
          this._secondaryImg.removeAttribute('height');
          this._secondaryImg.classList.remove('is-hidden');
        } else {
          this._secondaryImg.classList.add('is-hidden');
        }
      }

      const productUrl = btn.dataset.productUrl;
      const productTitle = btn.dataset.productTitle;
      if (productUrl) {
        this.querySelectorAll('[data-card-product-link]').forEach((link) => {
          link.href = productUrl;
        });
        if (productTitle) {
          this.querySelectorAll('[data-card-title-link]').forEach((link) => {
            link.textContent = productTitle;
          });
        }
      }

      this._updatePrice(
        btn.dataset.price,
        btn.dataset.comparePrice,
        btn.dataset.onSale === 'true',
        btn.dataset.soldOut === 'true'
      );

      try {
        const sizes = JSON.parse(btn.dataset.sizes || '[]');
        this._updateSizes(sizes, productUrl);
      } catch (_) {}
    }

    _updatePrice(price, comparePrice, onSale, soldOut) {
      const priceEl = this.querySelector('.price');
      if (!priceEl) return;

      priceEl.classList.toggle('price--on-sale', onSale);
      priceEl.classList.toggle('price--sold-out', soldOut);

      const regularEl = priceEl.querySelector('.price__regular .price-item--regular');
      if (regularEl) regularEl.innerHTML = price;

      const salePriceEl = priceEl.querySelector('.price-item--sale');
      if (salePriceEl) salePriceEl.innerHTML = price;

      const compareEl = priceEl.querySelector('.price__sale s.price-item--regular');
      if (compareEl) compareEl.innerHTML = comparePrice || '';
    }

    _updateSizes(sizes, productUrl) {
      const container = this.querySelector('.comp-card__sizes');
      if (!container) return;

      container.innerHTML = sizes
        .map((s) => {
          const soldOut = !s.available;
          const cls = soldOut ? 'comp-size-btn text-body-3 different-colors-10 comp-size-btn--sold-out' : 'comp-size-btn text-body-3 different-colors-10';
          return `<button type="button" class="${cls}" data-variant-id="${s.id}" data-available="${s.available}" aria-pressed="false">${s.label}</button>`;
        })
        .join('');

      this._initSizes();

      const quickViewBtn = this.querySelector('[data-quick-view-btn]');
      if (quickViewBtn && productUrl) quickViewBtn.setAttribute('data-product-url', productUrl);
    }

    _onMoreClick(e) {
      e.currentTarget.hidden = true;
      this.querySelectorAll('.card__swatch--hidden').forEach((btn) => {
        btn.classList.remove('card__swatch--hidden');
      });
    }
  }

  customElements.define('comp-product-card', CompProductCard);
}
